<template>
  <v-dialog
    :value="active"
    persistent
    transition="dialog-bottom-transition"
    style="z-index: 2000"
    :fullscreen="true"
    :scrollable="true"
  >
    <v-card
      class="text-center"
      :class="
        getTheme() == 'dark' ? 'outlined elevation-0' : 'flat elevation-0'
      "
      :style="getTheme() == 'dark' ? '' : 'border-bottom: 1px solid lightgray'"
    >
      <v-card-title
        :style="
          getTheme() == 'dark'
            ? 'background-color: #505050'
            : 'background-color: white; border-bottom: 1px solid lightgray'
        "
        :class="getTheme() == 'dark' ? 'white--text' : '#505050--text'"
        class="title font-weight-regular pl-5 pr-3"
      >
        <v-icon
          :class="getTheme() == 'dark' ? 'white--text' : 'primary--text'"
          class="mr-2"
          medium
          >mdi-satellite</v-icon
        >
        {{ $t("fabricSelectTemplateDialogTitle") }}
        <v-spacer></v-spacer>
        <v-btn
          text
          medium
          @click="active = false"
          style="min-width: 0; width: 20px"
        >
          <v-icon
            medium
            :class="getTheme() == 'dark' ? 'white--text' : 'primary--text'"
            >mdi-close-box</v-icon
          >
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-container fluid class="py-0">
          <v-layout row class="mx-1 mt-3" v-if="subCategorys.length > 0">
            <v-btn
              class="mx-1 mb-1 elevation-0"
              :text="currentTag != ''"
              :outlined="currentTag != ''"
              small
              rounded
              color="accent"
              @click="getSubcategory('')"
              >{{ $t("msgShowAll") }}</v-btn
            >
            <div v-for="(i, ind) in subCategorys" :key="ind">
              <v-btn
                class="mx-1 mb-1 elevation-0"
                :text="currentTag != i"
                :outlined="currentTag != i"
                small
                rounded
                color="accent"
                @click="getSubcategory(i)"
                >{{ i }}</v-btn
              >
            </div>
          </v-layout>
          <v-layout row class="px-1 pt-2">
            <v-flex
              v-for="(item, index) in templateRealVar"
              :key="index"
              :id="item.id"
              xs12
              sm6
              md4
              lg3
              xl2
            >
              <v-card
                outlined
                class="mx-1 mb-2"
                style="background-color: #fcfcfc"
                @click="selectedItem(item.id)"
              >
                <v-card-title
                  class="primary white--text justify-center subtitle-2 ma-0 py-1"
                  >{{ item.title }}</v-card-title
                >
                <v-card-text class="pa-0">
                  <v-img
                    contain
                    v-if="item.allowAutoPreview"
                    :src="item.imagePr"
                    class="hover-item d-flex align-end ma-1"
                    style="max-height: 133px"
                  >
                    <div
                      v-if="desc && item.description.length > 0"
                      style="background: rgba(0, 0, 0, 0.4)"
                      class="pa-2 py-1 white--text"
                    >
                      {{ item.description }}
                    </div>
                  </v-img>
                  <v-img
                    v-else
                    :src="item.previewImage"
                    class="hover-item d-flex align-end"
                  >
                    <div
                      v-if="aDesc && item.description.length > 0"
                      style="background: rgba(0, 0, 0, 0.4)"
                      class="pa-2 py-1 white--text"
                    >
                      {{ item.description }}
                    </div>
                  </v-img>
                  <v-btn
                    v-if="item.description.length > 0"
                    fab
                    absolute
                    top
                    right
                    x-small
                    color="accent"
                    style="margin-top: 25px; margin-right: -8px"
                    class="elevation-0"
                    @click="aDesc = !aDesc"
                    @click.stop
                  >
                    <v-icon medium color="white"
                      >mdi-information-variant</v-icon
                    >
                  </v-btn>
                </v-card-text>
              </v-card>
            </v-flex>
            <v-flex v-if="currentPage < currentPages" xs12 sm6 md4 lg3 xl2>
              <v-btn
                x-large
                text
                color="accent"
                class="mx-1 elevation-0"
                @click="getTemplatePages(1)"
              >
                <v-icon x-large class="mr-1">mdi-chevron-right</v-icon
                >{{ $t("msgMore") }}
              </v-btn>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { G_TEMPLATE_SELECTION_PAGE_SIZE } from "@/constants";
export default {
  name: "dialog-template-selection",
  data() {
    return {
      initSearch: true,
      templateRealVar: [],
      tempRealVar: [],
      currentTag: "",
      subCategorys: [],
      currentPage: 1,
      currentPages: 1,
      currentPageSize: G_TEMPLATE_SELECTION_PAGE_SIZE,
    };
  },
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    desc: {
      type: Boolean,
      required: true,
    },
    templateVar: {
      type: Array,
      required: true,
    },
  },
  computed: {
    active: {
      get() {
        if (this.value && this.initSearch) this.initState();
        return this.value;
      },
      set: function (value) {
        this.initSearch = true;
        this.$emit("input", value);
      },
    },
    aDesc: {
      get() {
        return this.desc;
      },
      set: function (value) {
        this.$emit("update:desc", value);
      },
    },
  },
  methods: {
    selectedItem(id) {
      this.initSearch = false;
      this.$emit("selectedId", id);
    },
    getSubcategory(i) {
      this.currentTag = i;
      this.currentPage = 1;
      this.getTemplatePages(0);
    },
    getTemplatePages(i) {
      this.currentPage += i;
      let item = (this.currentPage - 1) * this.currentPageSize;

      if (this.currentTag == "") {
        this.currentPages = Math.ceil(
          this.tempRealVar.length / this.currentPageSize
        );
        this.templateRealVar = this.tempRealVar.slice(
          0, // ali "item" za pages
          item + this.currentPageSize
        );
      } else {
        this.templateRealVar = this.tempRealVar.filter((x) => {
          return x.keywords == this.currentTag;
        });
        this.currentPages = Math.ceil(
          this.templateRealVar.length / this.currentPageSize
        );

        this.templateRealVar = this.templateRealVar.slice(
          0, // ali "item" za pages
          item + this.currentPageSize
        );
      }
      console.log(" => Page " + this.currentPage + " of " + this.currentPages);
    },
    initState() {
      if (this.initSearch) {
        this.currentPage = 1;
        this.currentPages = 1;

        this.initSearch = false;
        this.currentTag = "";

        this.templateRealVar = this.templateVar;
        this.tempRealVar = this.templateVar;

        this.subCategorys = [];
        this.templateRealVar.forEach((x) => {
          if (x.keywords != "" && this.subCategorys.indexOf(x.keywords) === -1)
            this.subCategorys.push(x.keywords);
        });
        this.subCategorys.sort();
        this.getTemplatePages(0);
      }
    },
  },
};
</script>

<style scoped>
</style>
